import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["data-tooltip", "type"]
const _hoisted_2 = {
  key: 0,
  style: {"width":"10px"}
}
const _hoisted_3 = {
  key: 1,
  style: {"flex":"1"}
}
const _hoisted_4 = {
  key: 2,
  style: {"width":"10px"}
}

import { PropType, computed, useSlots } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ApButton',
  props: {
        title: String,
        icon: String,
        iconAfter: String,
        tooltip: String,
        type: {
            type: String as PropType<'submit' | 'button' | 'reset'>,
            default: 'button',
        },
        btnClass: {
            default: 'btn-primary',
            type: [String, Array, Object],
        },
    },
  setup(__props) {

const props = __props;

    
    const slots = useSlots();

    const needSpace = computed(() => {
        return (props.title || !!slots.default) && (props.icon || !!slots.icon);
    });
    const needSpaceAfter = computed(() => {
        return (props.title || !!slots.default) && (props.iconAfter || !!slots['icon-after']);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["ap-btn", __props.btnClass]),
    "data-tooltip": __props.tooltip,
    type: __props.type
  }, [
    _renderSlot(_ctx.$slots, "icon", {}, () => [
      (__props.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["ap-icon", [__props.icon]])
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    (needSpace.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    (__props.title)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (needSpaceAfter.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "icon-after", {}, () => [
      (__props.iconAfter)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["ap-icon", [__props.iconAfter]])
          }, null, 2))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})